import React from "react";
import { useTranslation } from "react-i18next";
import { Apple, Play } from "lucide-react";
import { APP_DOWNLOAD } from "../config";

export const DownloadApp = ({ variant = "default", className = "" }) => {
  const { t } = useTranslation();

  const Badge = ({ store, icon: Icon, label, href }) => {
    const disabled = !href || href === "#";
    const content = (
      <div
        data-testid={`download-${store}-btn`}
        title={disabled ? t("download.comingSoon") : label}
        className={`flex items-center gap-2.5 px-4 py-2.5 rounded-xl bg-stone-text text-white transition-all ${
          disabled ? "opacity-60 cursor-not-allowed" : "hover:-translate-y-0.5 hover:shadow-lg cursor-pointer"
        }`}
      >
        <Icon className="w-5 h-5" />
        <div className="text-left leading-tight">
          <div className="text-[10px] opacity-80">
            {disabled ? t("download.comingSoon") : "Download on"}
          </div>
          <div className="text-sm font-semibold">{label}</div>
        </div>
      </div>
    );
    if (disabled) return content;
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">{content}</a>
    );
  };

  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid={`download-app-${variant}`}>
      <Badge store="ios" icon={Apple} label={t("download.ios")} href={APP_DOWNLOAD.ios} />
      <Badge store="android" icon={Play} label={t("download.android")} href={APP_DOWNLOAD.android} />
    </div>
  );
};
